export const Colors = [
  {
    id: 1,
    label: "color1",
    color: "#64bd00",
    hover: "#427700",
  },
  {
    id: 2,
    label: "color2",
    color: "#40bad5",
    hover: "#0489a6",
  },
  {
    id: 3,
    label: "color3",
    color: "#ff1e56",
    hover: "#c81b46",
  },
  {
    id: 4,
    label: "color4",
    color: "#ff7315",
    hover: "#d55b0a",
  },
  {
    id: 5,
    label: "color5",
    color: "#aa00fd",
    hover: "#74239c",
  },
  {
    id: 6,
    label: "color6",
    color: "#d97200",
    hover: "#c85d00",
  },
  {
    id: 7,
    label: "color7",
    color: "#ff00ff",
    hover: "#ca01ca",
  },
  {
    id: 8,
    label: "color8",
    color: "#ff5d56",
    hover: "#f03e37",
  },
]
